module.exports = __webpack_public_path__ + "static/img/recommend-list-8.39c4428.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/main/recommend-list-8.png
// module id = Mi3e
// module chunks = 1